import { ACT_NVT_CHANGE } from "../actions/ActionTypes";

const initialState = {
  noveltyList:[],
};

export default function(state = initialState, action) {
	if (action.type === ACT_NVT_CHANGE) {
		return Object.assign({}, state, action.props);
	}
	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/NoveltyReducer.js